
$(document).ready(function () {
    let isMobile = document.body.clientWidth < 768;

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const $emailInput = $('#form-switch2-gift-box .email-address input');
    const $validateMessage = $('#form-switch2-gift-box .validate-message');
    const $submitMessage = $('#form-switch2-gift-box .submit-message');


    $('#form-switch2-gift-box').submit(function () {
        $validateMessage.html('');
        let email = $emailInput.val();
        if (!email) {
            $validateMessage.html('E-mail Address is required.');
            $emailInput.focus();
            return false;
        }
        if (!emailPattern.test(email)) {
            $validateMessage.html('Invalid email.');
            $emailInput.focus();
            return false;
        }

        $.ajax({
            url: `https://user.supcase.com/api/mumba/open/switch2-gift-box`,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({email: email}),
            success: function (res) {
            }
        });
        $("#form-switch2-gift-box .form").hide();
        $submitMessage.show();
        return false;
    });


});
